<template>
  <div id="performers">
    <v-container>
      <v-row justify="center">
        <v-col md="8">
          <h1>Performers</h1>
          <v-data-table
            :headers="headers"
            :items="performers"
            :page.sync="page"
            :options.sync="options"
            :server-items-length="totalCount"
            :loading="loading"
            :items-per-page="itemsPerPage"
            class="elevation-1"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-dialog
                  v-model="dialog"
                  max-width="300px"
                  v-if="isAuthenticated"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      New Performer
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row justify="center">
                          <v-col>
                            <v-text-field
                              v-model="editedItem.name"
                              label="Performer name"
                              @keydown.enter="save"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">
                        Cancel
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="save">
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title>
                      Are you sure you want to delete this item?
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">
                        Cancel
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="deleteItemConfirm"
                      >
                        OK
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }" v-if="isAuthenticated">
              <v-icon
                class="mr-2"
                v-if="!item.isUnknown"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon color="red darken-4" v-if="!item.isUnknown" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import apiClient from "@/utils/apiClient";
import { mapGetters } from "vuex";

export default {
  name: "Performers",
  data: () => ({
    totalCount: 0,
    loading: true,
    options: {},
    page: 1,
    pageCount: 0,
    itemsPerPage: 30,
    headers: [
      {
        text: "Name",
        value: "name",
      },
      {
        text: "Songs Count",
        value: "songsCount",
        sortable: false,
      },
    ],
    performers: [],

    dialog: false,
    dialogDelete: false,
    editedIndex: -1,
    editedItem: {
      id: null,
      name: "",
    },
    defaultItem: {
      id: null,
      name: "",
    },
    defaultActionsHeader: {
      text: "Actions",
      value: "actions",
      sortable: false,
    },
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Performer" : "Edit Performer";
    },
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  mounted() {
    if (this.isAuthenticated) {
      this.headers.push(this.defaultActionsHeader);
    }
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    isAuthenticated() {
      this.headers.push(this.defaultActionsHeader);
    },
  },
  methods: {
    loadData() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const options = { page, itemsPerPage, sortBy: sortBy[0] || null, sortDesc: sortDesc[0] || null };
      apiClient
        .getPerformers(options)
        .then((response) => {
          this.loading = false;
          this.totalCount = response.data.totalCount;
          this.performers = response.data.records;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.performers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.performers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      const { id } = this.editedItem;
      const performer = { id };
      apiClient
        .deletePerformer(performer)
        .then(() => {
          this.loadData();
        })
        .catch((error) => {
          console.log(error);
        });
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      const { id, name } = this.editedItem;
      const performer = { id, name };
      if (this.editedIndex > -1) {
        // Edit
        apiClient
          .updatePerformer(performer)
          .then(() => {
            this.loadData();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        // Create
        apiClient
          .createPerformer(performer)
          .then(() => {
            this.loadData();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      this.close();
    },
  },
};
</script>
